import {Component, OnInit} from '@angular/core';
import {Grid} from '../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../shared/Services/broadcast.service';
import {Router} from '@angular/router';
import {WorkFormItemService} from '../../Services/work-form-item.service';

@Component({
  selector: 'app-packaging-label',
  templateUrl: './work-form-item-overview.component.html',
  styleUrls: ['./work-form-item-overview.component.scss']
})

export class WorkFormItemOverviewComponent implements OnInit {

  public grid: Grid;
  public specialButtons = [];

  constructor(
    private workFormItemService: WorkFormItemService,
    private broadcastService: BroadcastService,
    private router: Router,
    private translator: TranslateService,
  ) { }

  ngOnInit() {
    this.specialButtons.push({
      btnIcon: 'fa fa-plus',
      btnName: this.translator.instant('global.add'),
      btnUrl: '',
      method: 'newWorkFormItem',
      btnCustomClass: 'btn btn-primary ripple'
    });
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.work_form_item.content',
          prop: 'content',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          isHtml: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          maxWidth: 60,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: (row) => {
                if (row.id) {
                  this.workFormItemService.removeWorkFormItem(row.id).subscribe(() => {
                    this.refreshGrid(true);
                  });
                }
              },
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-edit fa-lg',
              tooltip: 'global.edit',
              onclick: (row) => {
                if (row.id) {
                  this.router.navigateByUrl('/back-office/work-form-item/' + row.id + '/edit');
                }
              },
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.workFormItemService,
      rememberURL: this.router.url,
      method: 'getWorkFormItems',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      simpleSearch: false,
    };
  }

  callFunction(method) {
    this[method]();
  }

  newWorkFormItem() {
    this.router.navigateByUrl('/back-office/work-form-item/manage');
  }
  refreshGrid(event) {
    if (event) {
      this.broadcastService.broadcast('refreshGrid', 'getWorkFormItems');
    }
  }
}
